import EditProduct from "@/components/product/edit";
import ModalProvider from "@repo/components/src/globalProviders/modal";
import { Column } from "@repo/components/src/shared/dataGrid/types";
import {
  Avatar,
  AvatarFallbackText,
  AvatarImage,
} from "@repo/components/src/ui/avatar";
import { Button, ButtonText } from "@repo/components/src/ui/button";
import { HStack } from "@repo/components/src/ui/hstack";
import { Text } from "@repo/components/src/ui/text";
import { formatMoneyFromFragment } from "@repo/components/src/utils/money";
import { CurrencyCode } from "@repo/components/src/utils/money/currencies";
import { ProductsSelectionQuery } from "@repo/graphql/documents/product/query.generated";

type ColumnEdge = ProductsSelectionQuery["product"]["list"]["edges"][number];

const buildProductColumns = (
  currency: CurrencyCode | null,
): Column<ColumnEdge, object>[] => [
  {
    id: "name",
    header: "Producto",
    width: 350,
    render: (node) => {
      const item = node.node;
      const product = item;
      const image = product.image;
      return (
        <HStack space="sm" className="items-center">
          <Avatar size="xs">
            <AvatarFallbackText>{product.name}</AvatarFallbackText>
            <AvatarImage source={{ uri: image?.url }} />
          </Avatar>
          <Button
            size="sm"
            variant="link"
            action="muted"
            onPress={() => {
              ModalProvider.show({
                children: (
                  <EditProduct productId={product.id} currency={currency} />
                ),
              });
            }}
          >
            <ButtonText
              numberOfLines={1}
              isTruncated
              className="text-typography-600"
            >
              {product.name}
            </ButtonText>
          </Button>
        </HStack>
      );
    },
    sortable: true,
    sortValue: "name",
  },
  {
    id: "price",
    header: "Precio",
    width: 100,
    render: (node) => {
      const item = node.node;
      const product = item;
      return (
        <Text size="sm" numberOfLines={1} isTruncated action="muted">
          {formatMoneyFromFragment(product.price)}
        </Text>
      );
    },
    sortable: true,
    sortValue: "price",
  },
  {
    id: "description",
    header: "Descripción",
    render: (node) => {
      const item = node.node;
      const product = item;
      return (
        <Text
          size="sm"
          numberOfLines={1}
          isTruncated
          action="muted"
          className="block"
        >
          {product.description}
        </Text>
      );
    },
    sortable: true,
    sortValue: "price",
  },
];

export default buildProductColumns;
